import HarmonicsInitial from './harmonics-initial';
import HarmonicsNegative from './harmonics-negative';
import HarmonicsPositive from './harmonics-positive';
import FilterService from '../../services/filter';

export interface HarmonicSequenceValue {
  sequenceName: string;
  sequenceFrequency: string;
  _seqFrequency: number;
  sequenceAmplitude: string;
  filterValues: {
    filterAmplitude: number | null;
    filterAttenuation: number | null;
  };
}

export default class HarmonicsDataModel {
  systemClock: number;
  targetFrequency: number;
  filter?: FilterService;
  harmonicsSpurLevel: number;
  pptSpurLevel: number;
  constructor(
    systemClock: number,
    targetFrequency: number,
    harmonicsSpurLevel: number,
    pptSpurLevel: number,
    filter?: FilterService,
  ) {
    this.systemClock = systemClock;
    this.targetFrequency = targetFrequency;
    this.harmonicsSpurLevel = harmonicsSpurLevel;
    this.pptSpurLevel = pptSpurLevel;
    if (filter) {
      this.filter = filter;
    }
  }

  get rawHarmonicsTable(): HarmonicSequenceValue[][] {
    const multiplier = 16;
    const row1 = this.getHarmonicsList(
      this.systemClock,
      this.targetFrequency,
      this.harmonicsSpurLevel,
      multiplier,
      1,
      this.pptSpurLevel,
      this.filter,
    );
    const row2 = this.getHarmonicsList(
      this.systemClock,
      this.targetFrequency,
      this.harmonicsSpurLevel,
      multiplier,
      2,
      this.pptSpurLevel,
      this.filter,
    );
    const row3 = this.getHarmonicsList(
      this.systemClock,
      this.targetFrequency,
      this.harmonicsSpurLevel,
      multiplier,
      3,
      this.pptSpurLevel,
      this.filter,
    );

    const rows = [];
    rows.push(row1);
    rows.push(row2);
    rows.push(row3);

    return rows;
  }

  get unfilteredFundamentalHarmonic(): HarmonicSequenceValue[] {
    const systemClock = this.systemClock;
    const targetFrequency = this.targetFrequency;
    const multiplier = 16;
    const harmonicsSpurLevel = this.harmonicsSpurLevel;
    const pptSpurLevel = this.pptSpurLevel;
    return this.getHarmonicsList(systemClock, targetFrequency, harmonicsSpurLevel, multiplier, 1, pptSpurLevel);
  }

  private getHarmonicsList(
    systemClock: number,
    targetFrequency: number,
    harmonicsSpurLevel: number,
    multiplier = 16,
    harmonicsSequence = 1,
    pptSpurLevel = -50,
    filter?: FilterService,
  ): HarmonicSequenceValue[] {
    const seqList = [];
    for (let i = 0; i < multiplier; i++) {
      if (i === 0) {
        const initialItem = new HarmonicsInitial(
          i,
          harmonicsSequence,
          systemClock,
          targetFrequency,
          harmonicsSpurLevel,
          pptSpurLevel,
          filter,
        );
        seqList.push(initialItem);
      } else {
        const minusHarmonics = new HarmonicsNegative(
          i,
          harmonicsSequence,
          systemClock,
          targetFrequency,
          harmonicsSpurLevel,
          pptSpurLevel,
          filter,
        );

        const plusHarmonics = new HarmonicsPositive(
          i,
          harmonicsSequence,
          systemClock,
          targetFrequency,
          harmonicsSpurLevel,
          pptSpurLevel,
          filter,
        );

        seqList.push(minusHarmonics);
        seqList.push(plusHarmonics);
      }
    }
    return seqList;
  }
}
